export const iconFontAwesomePhotosImagesChalkboard = (
	<i className="fa-solid fa-chalkboard"></i>
);
